module.exports = __webpack_public_path__ + "static/media/heading_send-gochi@2x.7dcfa511.png";